'use client';

import { useLocale } from 'next-intl';

import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';

import { Button } from '../../components/button/button';
import { HOMEPAGE_PATH } from '../../utils/constants/local-paths';
import { loginHandler } from '../../utils/helpers/login-handler';

type ErrorPageContentActionsProps = {
  actionsCmsContent: {
    goBackToHomepage: string;
    signIn: string;
  };
  returnToBaseUrl: boolean;
};

const handleLogin = async (locale: string, returnToBaseUrl: boolean) =>
  returnToBaseUrl
    ? await loginHandler({
        authorizationParameters: { ui_locales: locale },
        options: { redirectTo: HOMEPAGE_PATH },
      })
    : await loginHandler({ authorizationParameters: { ui_locales: locale } });

export const ErrorPageContentActions = ({
  actionsCmsContent,
  returnToBaseUrl,
}: ErrorPageContentActionsProps) => {
  const locale = useLocale();
  const { isAuthenticated } = useUserContext();

  return (
    <>
      <Button to={HOMEPAGE_PATH} variant={ButtonVariant.Secondary}>
        {actionsCmsContent.goBackToHomepage}
      </Button>
      {!isAuthenticated && (
        <Button onClick={() => handleLogin(locale, returnToBaseUrl)}>
          {actionsCmsContent.signIn}
        </Button>
      )}
    </>
  );
};
